export const TURN_EMOTION_TOPIC = 'noesis.turn-emotion.v1';

export const turnEmotionLabels = [
  'angry',
  'disgusted',
  'fearful',
  'happy',
  'neutral',
  'sad',
  'surprised',
] as const;

export type TurnEmotionLabel = (typeof turnEmotionLabels)[number];
export type TurnEmotionStatus = 'ready' | 'insufficient' | 'unavailable' | 'skipped';
export type TurnEmotionRelation =
  | 'agree'
  | 'conflict'
  | 'single_modality'
  | 'conflict_with_text'
  | 'insufficient';

export interface TurnEmotionCue {
  modality: 'audio' | 'video';
  label: TurnEmotionLabel;
}

export interface TurnEmotionEvent {
  schema_version: '1';
  type: 'turn_emotion';
  turn_id: string;
  message_id: string;
  input_modality: 'audio' | 'text';
  status: TurnEmotionStatus;
  usable: boolean;
  relation: TurnEmotionRelation | null;
  overall_label: TurnEmotionLabel | null;
  cues: TurnEmotionCue[];
  reason: string | null;
  service_latency_ms: number | null;
  completed_at_ms: number;
}
